<div class="filters">
	<div>
		<button mat-button [class]="isToday?'today':'today-active'" (click)="setToday()" type="button">Today</button>
		<mat-form-field appearance="outline" class="date-search">
			<mat-label>Choose a date</mat-label>
			<input matInput [matDatepicker]="picker" [formControl]="dateControl" (click)="picker.open()">
			<mat-datepicker-toggle matIconSuffix [for]="picker"></mat-datepicker-toggle>
			<mat-datepicker #picker></mat-datepicker>

			@if (dateControl.invalid) {
				<mat-error>Invalid start date</mat-error>
			}
		</mat-form-field>
	</div>
	<div>
		<mat-form-field class="search">
			<mat-icon matPrefix>search</mat-icon>
			<input matInput placeholder="Search" [formControl]="searchControl" (keydown.enter)="search($event)">
			<button matSuffix mat-icon-button aria-label="Clear"
			        (click)="search();">
				<mat-icon>close</mat-icon>
			</button>
		</mat-form-field>
	</div>
</div>


<div class="content">
	<table mat-table [dataSource]="dataSource">
		<ng-container matColumnDef="appointmentTime">
			<th mat-header-cell *matHeaderCellDef>Time</th>

			<td mat-cell *matCellDef="let row"
			    [matTooltip]="row.appointmentTime | orgDate : 'long'">
				<div>{{ row.appointmentTime | orgDate : 'shortTime' }}</div>
			</td>
		</ng-container>

		<ng-container matColumnDef="patientName">
			<th mat-header-cell *matHeaderCellDef>Name</th>

			<td mat-cell *matCellDef="let row">
				<div class="name">{{ getDisplayName(row) }}</div>
				<div class="sub">{{ row.patient.mrn }} | {{ row.patient | ageSex }}</div>
			</td>
		</ng-container>

		<ng-container matColumnDef="appointmentType">
			<th mat-header-cell *matHeaderCellDef>Type</th>
			<td mat-cell *matCellDef="let row">
				{{ row.appointmentType }}
			</td>
		</ng-container>

		<ng-container matColumnDef="providerName">
			<th mat-header-cell *matHeaderCellDef>
				<div class="table-filter-container">
					<div class="table-filter-title">
						Provider
					</div>
					<button mat-icon-button [matMenuTriggerFor]="providerFilterMenu">
						<mat-icon [class]="getFilterClass(_providerChecks,appointmentsService.sortedProviders)">filter_list</mat-icon>
					</button>
					<mat-menu #providerFilterMenu="matMenu">
						<div class="menu-header">
							<mat-checkbox (click)="$event.stopPropagation()" (change)="checkProviders($event)" [(ngModel)]="allProvidersChecked" ></mat-checkbox>
						</div>
						@for (provider of appointmentsService.sortedProviders; track provider.id) {
							<div
								(click)="$event.stopPropagation();setProviderChecks(toggleValue(provider.id,_providerChecks))"
								class="menu-item">
								<mat-icon [class]="getCheckClass(provider.id,_providerChecks)">check</mat-icon>
								{{ provider.first_name }} {{ provider.last_name }}
							</div>
						}
					</mat-menu>
				</div>
			</th>
			<td mat-cell *matCellDef="let row"> {{ row.providerName }}</td>
		</ng-container>

		<ng-container matColumnDef="status">
			<th mat-header-cell *matHeaderCellDef>
				<div class="table-filter-container">
					<div class="table-filter-title">
						Status
					</div>
					<button mat-icon-button [matMenuTriggerFor]="statusFilterMenu">
						<mat-icon [class]="getFilterClass(_statusChecks,appointmentsService.sortedStatuses)">filter_list</mat-icon>
					</button>
					<mat-menu #statusFilterMenu="matMenu">
						<div class="menu-header">
							<mat-checkbox (click)="$event.stopPropagation()" (change)="checkStatuses($event)" [(ngModel)]="allStatusesChecked" ></mat-checkbox>
						</div>
						@for (status of appointmentsService.sortedStatuses; track status) {
							<div
								(click)="$event.stopPropagation(); setStatusChecks(toggleValue(formatStatus(status),_statusChecks))"
								class="menu-item">
								<mat-icon [class]="getCheckClass(formatStatus(status),_statusChecks)">check</mat-icon>
								{{ status }}
							</div>
						}
					</mat-menu>
				</div>
			</th>
			<td mat-cell *matCellDef="let row" (click)="$event.stopPropagation()">
				<app-status-pill [status]="row.tasks?.status ?? AppointmentStatus.Scheduled"
				                 (onStatusChange)="changeStatus(row, $event)"></app-status-pill>
			</td>
		</ng-container>

		<ng-container matColumnDef="tasks">
			<th mat-header-cell *matHeaderCellDef>
				<div class="table-filter-container">
					<div class="table-filter-title">
						Tasks
					</div>
					<button mat-icon-button [matMenuTriggerFor]="taskFilterMenu">
						<mat-icon [class]="getFilterClass(_taskChecks,appointmentsService.sortedTasks)">filter_list</mat-icon>
					</button>
					<mat-menu #taskFilterMenu="matMenu">
						<div class="menu-header">
							<mat-checkbox (click)="$event.stopPropagation()" (change)="checkTasks($event)" [(ngModel)]="allTasksChecked" ></mat-checkbox>
						</div>
						@for (taskCheck of appointmentsService.sortedTasks; track taskCheck) {
							@if (taskCheck.startsWith('HEADER_')) {
								<div class="menu-header" >
									{{ taskCheck.replace('HEADER_','') }}
								</div>
							} @else {
								<div
									(click)="$event.stopPropagation(); setTaskChecks(toggleValue(taskCheck,_taskChecks))"
									class="menu-item">
									<mat-icon [class]="getCheckClass(taskCheck,_taskChecks)">check</mat-icon>
									{{ taskCheck }}
								</div>
							}
						}
					</mat-menu>
				</div>
			</th>
			<td mat-cell *matCellDef="let row">
				<div class="pills">
					<app-tasks-pill [className]="getPillClassName(row,row.tasks?.tasks?.info)" [text]="'Info'"></app-tasks-pill>
					<app-tasks-pill [className]="getPillClassName(row,row.tasks?.tasks?.doc)" [text]="'Docs'"></app-tasks-pill>
					<app-tasks-pill [className]="getPillClassName(row,row.tasks?.tasks?.id)" [text]="'ID'"></app-tasks-pill>
					<app-tasks-pill [className]="getPillClassNameInsurance(row,row.tasks?.tasks?.insurance)"
					                [text]="'Insurance'"></app-tasks-pill>
					<app-tasks-pill [className]="getPillClassName(row,row.tasks?.tasks?.payment)"
					                [text]="'Payment'"></app-tasks-pill>
				</div>
			</td>
		</ng-container>

		<ng-container matColumnDef="actions">
			<th mat-header-cell *matHeaderCellDef></th>

			<td mat-cell *matCellDef="let row" (click)="$event.stopPropagation();">
				<span [matTooltipDisabled]="hasContactInfo(row)" matTooltip="Not subscribed to email or SMS">
					<button [disabled]="!hasContactInfo(row)" [matTooltipDisabled]="false" mat-icon-button
					        [matTooltip]="getResendToolTip(row)" (click)="resendIntake(row)">
						<mat-icon>send_email</mat-icon>
					</button>
				</span>

				<span [matTooltipDisabled]="row.patient?.phone != null" matTooltip="No phone number on file">
					<button mat-icon-button [disabled]="row.patient?.phone == null" matTooltipDisabled="false"
					        [matTooltip]="getPhoneToolTip(row)">
						<mat-icon>phone_call</mat-icon>
					</button>
				</span>

				<button mat-icon-button>
					<mat-icon>more_vert</mat-icon>
				</button>

				<a mat-icon-button [routerLink]="row.appointmentId">
					<mat-icon matTooltip="See appointment">chevron_right</mat-icon>
				</a>
			</td>
		</ng-container>

		<tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
		<tr mat-row *matRowDef="let row; columns: displayedColumns;" (click)="goto(row)"></tr>
	</table>
</div>
